import { render, staticRenderFns } from "./matron.component.vue?vue&type=template&id=69679500&scoped=true&"
import script from "./matron.component.vue?vue&type=script&lang=ts&"
export * from "./matron.component.vue?vue&type=script&lang=ts&"
import style0 from "./matron.component.vue?vue&type=style&index=0&id=69679500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69679500",
  null
  
)

export default component.exports